import React from "react";
import { CircleCheck, CircleX } from "lucide-react";
import { cn } from "util/cn";

interface AlignmentStanceButtonProps {
  variant: "agree" | "disagree";
  isSelected?: boolean;
  count?: number;
  showCount?: boolean;
  showText?: boolean;
  textOverride?: string;
  onClick?: () => void;
  disabled?: boolean;
  className?: string;
  title?: string;
}

const AlignmentStanceButton: React.FC<AlignmentStanceButtonProps> = ({
  variant,
  isSelected = false,
  count = 0,
  showCount = true,
  showText = false,
  textOverride,
  onClick,
  disabled = false,
  className,
  title,
}) => {
  const isAgree = variant === "agree";
  const selectedClass = isSelected
    ? isAgree
      ? "text-green-600 group-hover:stroke-white group-hover:fill-none"
      : "text-red-600 group-hover:stroke-white group-hover:fill-none"
    : "text-eoe-gray dark:text-eoe-dark-icon-stroke";
  const icon = isAgree ? <CircleCheck className={`size-5 group-hover:stroke-green-600 ${selectedClass}`} /> : <CircleX className={`size-5 group-hover:stroke-red-600 ${selectedClass}`} />;
  const text = textOverride || (isAgree ? "Agree" : "Disagree");
  const defaultTitle = isAgree ? "Agree with this claim" : "Disagree with this claim";
  

  return (
    <button
      className={cn(
        "group h-7 rounded-full px-1.5 gap-x-1 text-eoe-gray dark:text-eoe-dark-icon-stroke hover:bg-gray-300 dark:hover:bg-eoe-dark-icon-hover flex justify-center items-center transition-colors",
        disabled && "opacity-50 cursor-not-allowed",
        className
      )}
      onClick={onClick}
      disabled={disabled}
      title={title || defaultTitle}
    >
      {icon}
      {showText && (
        <span className="text-sm font-semibold">{text}</span>
      )}
      {showCount && (
        <span className={cn(
          "text-sm font-semibold",
          showText ? "" : ""
        )}>
          {count}
        </span>
      )}
    </button>
  );
};

export default AlignmentStanceButton;